module.exports = __webpack_public_path__ + "img/icon_school_white.5f12c3f5.svg";